import React from "react";
import { FormattedMessage, injectIntl, useIntl } from "react-intl";

const InjectMassage = (props) => {
  return React.createElement(FormattedMessage, props);
}

export const Translate = (key) => {
  const intl = useIntl();
  const stringExists = !!intl.messages[key];

  return stringExists ? intl.formatMessage({ id: key }) : key;
}


/**
 * `fallback` is what shows when the key has no entry in the language
 * file. Without one react-intl prints the key itself, so a label nobody
 * remembered to translate reaches the screen as "permissions.foo_index".
 */
export const TranslateWithoutHook = (key, fallback) => {
  let element = injectIntl(InjectMassage, {
    forwardRef: false
  });

  return React.createElement(element, { id: key, defaultMessage: fallback });
}


export default injectIntl(InjectMassage, {
  forwardRef: false
});

